import React from 'react';
import PropTypes from 'prop-types';

import { useSplitTest } from '../../hooks/split-test';

const withSplitTest = (Component) => {
  const ComponentWithSplitTest = (props) => (
    // eslint-disable-next-line react/destructuring-assignment
    <Component {...props} data={useSplitTest(props.data)} />
  );

  ComponentWithSplitTest.propTypes = {
    data: PropTypes.object,
  };

  ComponentWithSplitTest.displayName =
    Component.displayName || Component.name || 'PageTemplate';

  return ComponentWithSplitTest;
};

export default withSplitTest;
